var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: { "padding-top": "80px" },
        attrs: { id: "navigationPlaceholder" },
      },
      [_c("AdminNavigationV2", { attrs: { tid: _vm.tid } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-7" }, [
          _c(
            "h1",
            {
              staticStyle: {
                "font-size": "2em",
                "font-weight": "300",
                color: "#33475b",
              },
            },
            [_vm._v(_vm._s(_vm.organizationName) + " organizational dashboard")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/organizations/users/create/${_vm.tid}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-user-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Add user")]),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "btn btn-link btn-sm",
              attrs: {
                href: `/#/admin/organizations/workspaces/create/${_vm.tid}`,
                type: "button",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-plus",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", [_vm._v("Add workspace")]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-5 col-sm-6 text-right" }, [
          _vm.isSystemAdmin || _vm.isGlobalAdmin
            ? _c(
                "a",
                {
                  staticClass: "btn btn-success text-white",
                  staticStyle: { padding: "0.7em 2em" },
                  attrs: {
                    href: `/#/admin/organizations/manage`,
                    role: "button",
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-bank",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Manage organizations")]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr", {
      staticStyle: { "border-color": "#bbb", margin: "20px 0 30px" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "form-group", staticStyle: { "margin-bottom": "40px" } },
        [
          _c("div", { staticClass: "input-group mb-3" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchPhrase,
                  expression: "searchPhrase",
                },
              ],
              staticClass: "form-control form-control-lg",
              attrs: {
                type: "search",
                placeholder:
                  "Type to search for user, workspace or portfolio in your organization...",
              },
              domProps: { value: _vm.searchPhrase },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.handleSearch.apply(null, arguments)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.searchPhrase = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-append" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary",
                  staticStyle: { width: "60px" },
                  attrs: {
                    type: "button",
                    disabled: _vm.searchPhrase.length <= 1,
                  },
                  on: { click: _vm.handleSearch },
                },
                [
                  _c("i", {
                    staticClass: "fa-solid fa-magnifying-glass",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", staticStyle: { "margin-bottom": "40px" } },
        [
          _c("div", { staticClass: "col-sm-7" }, [
            _c("div", { staticClass: "card bg-light" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("h5", { staticClass: "card-title" }, [
                  _vm._v(_vm._s(_vm.organizationName)),
                ]),
                _vm._v(" "),
                _c("h6", { staticClass: "card-subtitle mb-2 text-muted" }, [
                  _vm._v("System admin: " + _vm._s(_vm.systemAdminEmail)),
                ]),
                _vm._v(" "),
                _c("h6", { staticClass: "card-subtitle mb-2 text-muted" }, [
                  _vm._v("Version: " + _vm._s(_vm.version)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "card-text" }, [
                  _vm._v(_vm._s(_vm.organizationDescription)),
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "card-link",
                    attrs: { href: `/#/admin/organizations/manage/${_vm.tid}` },
                  },
                  [_vm._v("Manage")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "card-link",
                    attrs: {
                      href: `/#/admin/organizations/manage/branding/${_vm.tid}`,
                    },
                  },
                  [_vm._v("Branding")]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "card-link",
                    attrs: {
                      href: `/#/admin/organizations/manage/sso/${_vm.tid}`,
                    },
                  },
                  [_vm._v("SSO")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-sm-5" }, [
            _c("table", { staticClass: "table table-sm table-striped" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", { attrs: { scope: "row" } }, [_vm._v("Users")]),
                  _vm._v(" "),
                  _c(
                    "td",
                    {
                      staticClass: "fg-color-blue",
                      attrs: { title: "All users and global admins" },
                    },
                    [_vm._v(_vm._s(_vm.numberOfUsers))]
                  ),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { attrs: { scope: "row" } }, [_vm._v("Workspaces")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "fg-color-blue" }, [
                    _vm._v(_vm._s(_vm.numberOfWorkspaces)),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { attrs: { scope: "row" } }, [_vm._v("Portfolios")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "fg-color-blue" }, [
                    _vm._v(_vm._s(_vm.numberOfPortfolios)),
                  ]),
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", { attrs: { scope: "row" } }, [_vm._v("Projects")]),
                  _vm._v(" "),
                  _c("td", { staticClass: "fg-color-blue" }, [
                    _vm._v(_vm._s(_vm.numberOfProjects)),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", staticStyle: { "margin-bottom": "40px" } },
        [
          _c(
            "div",
            {
              staticClass: "col-md-2 text-center",
              class:
                _vm.numberOfAccountRequests > 0
                  ? "fg-color-orange"
                  : "fg-color-blue",
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.numberOfAccountRequests))]),
              _vm._v(" "),
              _c(
                "a",
                {
                  class:
                    _vm.numberOfAccountRequests > 0
                      ? "fg-color-orange"
                      : "fg-color-blue",
                  attrs: {
                    href: `/#/admin/organizations/users/requests/${_vm.tid}`,
                  },
                },
                [
                  _vm._v(
                    "\n                    Account requests\n                "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-md-2 text-center fg-color-blue",
              attrs: { title: "Only users who are not locked" },
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.numberOfActiveUsers))]),
              _vm._v(" "),
              _c("span", [_vm._v("Active Users")]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2 text-center fg-color-blue" }, [
            _c("h1", [_vm._v(_vm._s(_vm.numberOfGlobalAdmins))]),
            _vm._v(" "),
            _c("span", [_vm._v("Global admins")]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col-md-2 text-center",
              class:
                _vm.numberOfLockedUsers > 0 ? "fg-color-red" : "fg-color-blue",
            },
            [
              _c("h1", [_vm._v(_vm._s(_vm.numberOfLockedUsers))]),
              _vm._v(" "),
              _c("span", [_vm._v("Locked users")]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2 text-center fg-color-blue" }, [
            _c("h1", [_vm._v(_vm._s(_vm.numberOfActiveSessions))]),
            _vm._v(" "),
            _c("span", [_vm._v("Sessions")]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Usage stats")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }